/**
 * Get environment variables at runtime
 * On server: from process.env
 * On client: NOT available (use proxy endpoints instead)
 *
 * This ensures sensitive tokens never reach the client
 */
export function getEnvVar(key: string, defaultValue?: string): string {
  // Only available on server
  if (typeof window === "undefined") {
    return process.env[key] || defaultValue || "";
  }

  // On client: return empty (should use proxy)
  return defaultValue || "";
}

export const getApiUrl = (): string => {
  return getEnvVar("VITE_PUBLIC_API_URL", "http://localhost:1337");
};

export const getApiToken = (): string => {
  return getEnvVar("VITE_API_TOKEN", "");
};

/**
 * Check if we're on server or client
 */
export const isServer = (): boolean => {
  return typeof window === "undefined";
};

/**
 * Public Strapi/API origin (e.g. https://back.d.trading).
 * Server: process.env. Client: Vite build-time variable only (no secrets).
 */
export const getPublicApiBaseUrl = (): string => {
  if (isServer()) {
    return getApiUrl().replace(/\/$/, "");
  }
  const viteUrl = import.meta.env.VITE_PUBLIC_API_URL;
  return typeof viteUrl === "string" ? viteUrl.replace(/\/$/, "") : "";
};
